import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface CustomTooltipMessage {
  label?: string;
  text: string;
}

@Component({
    selector: 'app-custom-tooltip',
    templateUrl: './custom-tooltip.component.html',
    styleUrls: ['./custom-tooltip.component.scss'],
    standalone: false
})
export class CustomTooltipComponent {
  @Input()
  public messages: CustomTooltipMessage[] = [
    {
      label: 'Original Value',
      text: '1,135.27234',
    },
  ];

  @Input()
  public columnName: string  = '';

  @Output()
  public rollbackClicked = new EventEmitter<void>();

  public animate = false;

  rollback() {
    this.animate = true;
    
    setTimeout(() => {
      this.animate = false;
      this.rollbackClicked.emit();
    }, 800);
  }
}
